// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cardActionArea {
  border-radius: 1rem !important;
  margin-bottom: 1rem !important;
  padding: 0;
}
.cardActionArea .card {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 1rem;
  padding: 2.5rem 1rem;
  cursor: pointer;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.2);
}
.cardActionArea .card .header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.cardActionArea .card .header .icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 100%;
}
.cardActionArea .card .header .title {
  font-size: 1.1rem;
  font-weight: bold;
  color: white;
}
.cardActionArea .card .value {
  color: white;
  font-size: 1.5rem;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/components/Card/Report/report.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;EACA,8BAAA;EACA,UAAA;AACF;AACE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,uCAAA;AACJ;AACI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AACN;AACM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AACR;AAEM;EACE,iBAAA;EACA,iBAAA;EACA,YAAA;AAAR;AAII;EACE,YAAA;EACA,iBAAA;EACA,iBAAA;AAFN","sourcesContent":[".cardActionArea {\n  border-radius: 1rem !important;\n  margin-bottom: 1rem !important;\n  padding: 0 ;\n\n  .card {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    border-radius: 1rem;\n    padding: 2.5rem 1rem;\n    cursor: pointer;\n    box-shadow: 0 0 12px rgba(0, 0, 0, 0.2);\n\n    .header {\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n\n      .icon {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 2rem;\n        height: 2rem;\n        border-radius: 100%;\n      }\n\n      .title {\n        font-size: 1.1rem;\n        font-weight: bold;\n        color: white;\n      }\n    }\n\n    .value {\n      color: white;\n      font-size: 1.5rem;\n      font-weight: bold;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
